/**
 * 服务拖动排序  by xcc
 */
import React from 'react';
import {message, Modal, Spin} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import ServeSortTable from "./ServeSortTable";

export default class ServeSort extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        title: "拖动排序",
        orderField: "sort"
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            spinning: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    showSortModal = () => {
        this.setState({
            visible: true
        });
    };

    handleOk = () => {
        this.setState({
            spinning: true
        });
        let that = this;
        let sortIds = [];
        let sortFields = [];
        let newSortList = this.serveSortTable.state.sortList;
        newSortList.forEach((item, index) => {
            sortIds.push(item.id);
            sortFields.push(item.sort);
        });
        let params = {
            ids: sortIds.toString(),
            sorts: sortFields.toString(),
        };
        this.request({
            url: "/cm-sites-mmp/homepageUrl/updateSort",
            body: params,
            method: "get",
            contentType: "json",
            callBack: (res) => {
                message.success("排序成功", 2, function () {
                    that.setState({
                        visible: false,
                        spinning: false
                    })
                    that.props.refreshList();
                });
            }
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false
        });
    };

    render() {
        let {title, orderField} = this.props;
        let {visible} = this.state;
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                width={"65%"}
            >
                <Spin spinning={this.state.spinning}>
                    <ServeSortTable orderField={orderField} ref={(serveSortTable) => this.serveSortTable = serveSortTable}/>
                </Spin>
            </Modal>
        )
    }
}